module.exports = __webpack_public_path__ + "14f71f6aa26990f25a4d6d0333aca2ec.jpeg";


//////////////////
// WEBPACK FOOTER
// ./assets/demo/bird.jpeg
// module id = ./assets/demo/bird.jpeg
// module chunks = 1